import { TemplateFbIg } from '../../../../../Chat.types';
import './TemplateRow.styles.scss';

type TemplateRowProps = {
  template: TemplateFbIg;
  isSelected?: boolean;
  onSelect: (template: TemplateFbIg) => void;
};

export default function TemplateRow({
  template,
  isSelected = false,
  onSelect,
}: TemplateRowProps) {
  return (
    <div
      className={`TemplateRow ${isSelected ? 'TemplateRow--selected' : ''}`}
      onClick={() => onSelect(template)}
    >
      <div className="TemplateRow__header">{template.name}</div>
      <div className="TemplateRow__content">{template.text}</div>
    </div>
  );
}
